import React from 'react';
import '../App.css';
import { Button } from './Button';
import './HeroSection.css';

function HeroSection() {
  return (
    <div className='hero-container'>
      <h1>FULL-STACK WEB<br/>DEVELOPER</h1>
      <div className='hero-btns'>
        <Button className='btns' buttonStyle='btn--primary' buttonSize='btn--hero'>
          View my work
        </Button>

      </div>
    </div>
  );
}

export default HeroSection;